var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"title_bg pa-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"title pa-2"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }